
import EventCardGeneral from '@/components/EventCardGeneral.vue';
import ShimmerEffect from "@/components/ShimmerEffect.vue";
export default {
  components: {
    EventCardGeneral,
    ShimmerEffect
  },
  head() {
    return {
      title: this.getMetaTitle(),
      meta: [{
        hid: "description",
        name: "description",
        content: this.getMetaDesc(),
      },
      {
        hid: "keywords",
        name: "keywords",
        content: this.getMetaKeyword(),
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.getMetaTitle(),
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.getMetaDesc(),
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.getMetaTitle(),
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.getMetaDesc(),
      },

      ],
      bodyAttrs: {
        class: this.showHelpModal ? 'pass-modal-open' : ''
      }
    };

  },
  data() {
    return {
      title: 'Title',
      description: 'Description',
      categoriesData: null,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      busy: false,
      productObj: [],
      listings: {},
      schemaData: [],
      loading: true,
      listingLoading: true,
      categoriesLoading: true,
      eventCategoryModal: false,

      //New code
      stateSlug: null,
      selectedState: null,
      activiteStatesList: [],
      titleDescState: 'goa',

    }
  },

  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.stateSlug = params.state;
      this.selectedState = params.state;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.stateSlug = this.$route.params.state;
    this.titleDescState = this.$route.params.state ? this.$route.params.state : 'goa';
    this.selectedState = this.stateSlug ? this.stateSlug : null
  },

  mounted() {
    console.log("F", this.stateSlug)
    this.getData();
    let pagination = (this.page - 1) * 8;
    if (pagination < 0) {
      pagination = 0;
    }
    this.getListings(pagination);
  },

  methods: {
    async getData() {
      this.categoriesData = await fetch(this.$config.fetchUrl + '/api/activityTypes/app/getTypeDetails/events/')
        .then(res => res.text());
      this.categoriesData = this.getCryptKey(this.categoriesData);
      this.categoriesLoading = false;
      this.activiteStatesList = await fetch(this.$config.fetchUrl + '/api/states/app/getAllActiveStates/')
        .then(res => res.text());
      this.activiteStatesList = this.getCryptKey(this.activiteStatesList);
    },

    getMetaTitle() {
      return 'Events in ' + this.titleDescState + ' - Events in ' + this.titleDescState + ' tomorrow | upcoming events in ' + this.titleDescState
    },
    getMetaDesc() {
      return 'Events in ' + this.titleDescState + ', events in ' + this.titleDescState + ' tomorrow, upcoming events in ' + this.titleDescState + ', events in ' + this.titleDescState + ' this weekend, events in ' + this.titleDescState + ' this week, music events in ' + this.titleDescState + ' tomorrow, party events in ' + this.titleDescState + ' tomorrow, party events in ' + this.titleDescState + ', events in ' + this.titleDescState + ' tomorrow'
    },

    getMetaKeyword() {
      return 'Events in ' + this.titleDescState + ', events in ' + this.titleDescState + ' tomorrow, upcoming events in ' + this.titleDescState + ', events in ' + this.titleDescState + ' this weekend, events in ' + this.titleDescState + ' this week, music events in ' + this.titleDescState + ' tomorrow, party events in ' + this.titleDescState + ' tomorrow, party events in ' + this.$route.params.state + ', events in ' + this.titleDescState + ' tomorrow'
    },

    cityDropdownClicked(event) {
      if (event && event.target.value) {
        this.$router.push({
          path: `/${event.target.value}/events/`
        })
      }
    },
    categoryBtnClicked(item) {
      if (item && item.slug) {
        if (this.stateSlug)
          this.$router.push({
            path: `/${this.stateSlug}/events/${item.slug}-events`
          })
        this.$router.push({
          path: `/events/${item.slug}-events`
        })
      }
    },

    getStateTitle(title) {
      if (this.activiteStatesList && this.activiteStatesList.states) {
        var stateTitle = this.activiteStatesList.states.filter(x => x.slug == title);
        return stateTitle && stateTitle.length > 0 ? stateTitle[0].name : '';
      }
      return ''
    },

    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++
          this.callback(this.page)
        }, 1000);
      }
    },

    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      let pagination = (page - 1) * 8;
      if (pagination < 0) {
        pagination = 0;
      }
      this.getListings(pagination);
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, year = null, month = null, categories = null, queryStr = null) {
      //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
      //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
      //this.listingLoading = true;

      // AXIOS api call to add review api
      let url = this.stateSlug ? `/api/events/getTomorrowEvents/${this.stateSlug}/${skip}` :   `/api/events/getTomorrowEvents/${skip}`
      this.$axios
        .get(url)
        .then((response) => {
          let value = this.getCryptKey(response.data);
          this.productObj.push(...value.events)
          this.listings = value;
          this.schemaData = this.listings && this.listings.events ? this.listings.events : [];
          if (skip == 0) {
            this.page = 1;

          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          this.$nextTick(() => {
            this.busy = false;
            this.listingLoading = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        });
    },
    eventDay(day) {
      switch (day) {
        case 'today':
          this.$router.push({
            path:`/${this.stateSlug}/events-today`
          })
          break;
        case 'tomorrow':
          this.$router.push({
            path:  `/${this.stateSlug}/events-tomorrow`
          })
          break;
        case 'weekend':
          this.$router.push({
            path: `/${this.stateSlug}/events-weekend`
          })
          break;
        default:
          this.$router.push({
            path: `/${this.stateSlug}/events`
          })
          break;
      }
    },
    eventNoStateDay(day) {
      switch (day) {
        case 'today':
          this.$router.push({
            path:`/events-today`
          })
          break;
        case 'tomorrow':
          this.$router.push({
            path: `/events-tomorrow`
          })
          break;
        case 'weekend':
          this.$router.push({
            path: `/events-weekend`
          })
          break;
        default:
          this.$router.push({
            path: `/events`
          })
          break;
      }
    },

  }

}
